var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 27.5V25.8333C23.3332 24.9493 22.982 24.1014 22.3569 23.4763C21.7317 22.8512 20.8839 22.5 19.9998 22.5H14.9998C14.1158 22.5 13.2679 22.8512 12.6428 23.4763C12.0177 24.1014 11.6665 24.9493 11.6665 25.8333V27.5",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 19.1667C19.3408 19.1667 20.8332 17.6743 20.8332 15.8333C20.8332 13.9924 19.3408 12.5 17.4998 12.5C15.6589 12.5 14.1665 13.9924 14.1665 15.8333C14.1665 17.6743 15.6589 19.1667 17.4998 19.1667Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8335 16.6667V21.6667",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 19.1667H23.3335",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomer);
export default __webpack_public_path__ + "static/media/new_customer.cc19b4fc6cdb834bbba8a7cdda1fde93.svg";
export { ForwardRef as ReactComponent };